
export function normalizePhone(phone) {
  if (!phone || typeof phone !== 'string') return '';
  const trimmed = phone.trim();
  const hasPlus = trimmed.startsWith('+');
  const digits = trimmed.replace(/\D+/g, '');
  return hasPlus ? `+${digits}` : digits;
}

const MILES_TO_KM = 1.60934;

/**
 * @param {Object} place
 * @param {'mi'|'km'} [unit='mi']
 * @returns {string|null}
 */
export function formatDistance(place, unit = 'mi') {
  if (!place) return null;
  let miles = null;
  if (
    typeof place.distanceMiles === 'number' &&
    Number.isFinite(place.distanceMiles)
  ) {
    miles = place.distanceMiles;
  } else if (
    typeof place.distance === 'number' &&
    Number.isFinite(place.distance)
  ) {
    miles = place.distance;
  }
  if (miles === null) return null;
  if (unit === 'km') {
    return `${(miles * MILES_TO_KM).toFixed(1)} km`;
  }
  return `${miles.toFixed(1)} mi`;
}

export function buildDirectionsUrl(place) {
  if (!place) return null;
  if (place.placeId) {
    const name = encodeURIComponent(place.name || '');
    return `https://www.google.com/maps/search/?api=1&query=${name}&query_place_id=${place.placeId}`;
  }
  if (place.address) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      place.address
    )}`;
  }
  return null;
}

export function truncatedName(name, max = 30) {
  if (!name || typeof name !== 'string') return '';
  if (name.length <= max) return name;
  return `${name.slice(0, max - 1).trimEnd()}…`;
}
